import React, { useState, useEffect, Fragment  } from 'react';
import axios from 'axios';
import parse, {domToReact} from 'html-react-parser';
import ShortcodeComponent from '../components/ShortcodeComponent';

const WordPressPage = ({ slug }) => {
  const [pageContent, setPageContent] = useState('');

  useEffect(() => {
    axios.get(`${tmp_path.site_url}/wp-json/wp/v2/pages?slug=${slug}`)
      .then(response => {
        const pageData = response.data[0];
        setPageContent(pageData.content.rendered);
      })
      .catch(error => console.log(error));
  }, [slug]);


  const transform = (node) => {
    // HTMLタグが<p>で、中身がショートコードのみの場合
    if (node.type === 'tag' && node.name === 'p') {
      const innerText = domToReact(node.children, {replace: transform});
      const isOnlyShortcode = node.children.length === 1 && node.children[0].type === 'text' && /^\[.*\]$/.test(node.children[0].data);

      if (isOnlyShortcode) {
        return <ShortcodeComponent shortcode={node.children[0].data} />;
      }

      // ショートコードだけではない場合、<p>タグは保持
      return <p>{innerText}</p>;
    }
  };

  return (
    <div>
      {/* {parse(pageContent, {replace: transform})} */}
      {/* {parse(pageContent)} */}
    </div>
  );
};

export default WordPressPage;